import { useMemo } from 'react';
import { Text } from '../../components/Text';
import { AgentFiltersFragment } from './agentFilters.generated';

interface OptionCheckboxProps {
  option: string;
  selected: string[];
  setSelected: (newSelection: string[]) => void;
}

const OptionCheckbox: React.FC<OptionCheckboxProps> = ({
  option,
  selected,
  setSelected,
}) => (
  <label className="flex items-start leading-tight text-gray-700 font-medium text-sm">
    <div className="flex items-center">
      {/* Zero-width space character, used to align checkbox properly */}
      &#8203;
      <input
        name={option}
        type="checkbox"
        className="focus:ring-blue-500 h-4 w-4 text-blue-600 border-gray-300 rounded ml-1 mr-3"
        checked={selected.includes(option)}
        onChange={(event) =>
          event.target.checked
            ? setSelected([...selected, option])
            : setSelected(selected.filter((selection) => selection !== option))
        }
      />
    </div>
    {option}
  </label>
);
interface AgentFilterProps {
  label: string;
  agents: AgentFiltersFragment[];
  filterField: (
    agent: AgentFiltersFragment,
  ) => (string | null)[] | null | undefined;
  selected: string[];
  setSelected: (newSelection: string[]) => void;
  sort?: boolean;
}

export const AgentFilter: React.FC<AgentFilterProps> = ({
  label,
  agents,
  filterField,
  selected,
  setSelected,
  sort = false,
}) => {
  const options = useMemo(() => {
    const unsortedOptions = agents.reduce<string[]>(
      (options, agent) =>
        Array.from(
          new Set([
            ...options,
            ...(filterField(agent)?.flatMap((product) => product ?? []) ?? []),
          ]),
        ),
      [],
    );
    return sort ? unsortedOptions.sort() : unsortedOptions;
  }, [agents, filterField, sort]);

  return (
    <>
      <fieldset className="space-y-2 mb-6">
        <legend>
          <Text.H6 className="!text-gray-900 !font-bold">{label}</Text.H6>
        </legend>
        {options.map((option) => (
          <OptionCheckbox
            key={option}
            option={option}
            selected={selected}
            setSelected={setSelected}
          />
        ))}
      </fieldset>
    </>
  );
};
